import React from 'react';

export const DigitalCard = ({ campaignPrefix, name, nameAlias, surname, secretary, federation, entity, code }) => {
  return (
    <div id="pdf-frame">
      <div
        className="pdf-page"
        style={{
          position: 'relative',
          width: '1016px',
          height: '638px',
          backgroundImage: `url('/assets/images/digital_card/digital_card_1_${campaignPrefix}.png')`,
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
        }}
      />

      <div
        className="pdf-page"
        style={{
          position: 'relative',
          width: '1016px',
          height: '638px',
          backgroundImage: `url('/assets/images/digital_card/digital_card_2_${campaignPrefix}.png')`,
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
        }}
      >
        <div style={{ position: 'absolute', top: '25px', left: '70px', fontSize: '30px', fontWeight: 'bold' }}>
          <span>{secretary}</span>
        </div>
        <div style={{ position: 'absolute', top: '124px', left: '70px', fontSize: '30px', fontWeight: 'bold' }}>
          <span>{federation}</span>
        </div>

        <div style={{ position: 'absolute', top: '223px', left: '70px', fontSize: '30px', fontWeight: 'bold' }}>
          <span>{entity}</span>
        </div>

        <div style={{ position: 'absolute', top: '320px', left: '70px', fontSize: '30px', fontWeight: 'bold' }}>
          <span>
            {nameAlias !== null ? nameAlias : name} {surname}
          </span>
        </div>

        <div style={{ position: 'absolute', top: '422px', left: '70px', fontSize: '30px', fontWeight: 'bold' }}>
          <span>{code}</span>
        </div>
      </div>
    </div>
  );
};
